import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Center, Flex, HStack, IconButton, Input, Table, Tbody, Td, Text, Thead, Tooltip, Tr, useDisclosure } from "@chakra-ui/react";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { BiServer, TiDelete } from "react-icons/all";
import { ticketSalesColumn } from "../../constants/tableData";
import { formatToCurrency, parseToNumber, sleep } from "../../utils/helper";
import "./TicketSaleTable.css";

function TicketSaleTable({ data, filter, status, onSaveAll, onRevertAll, isAllowEdit, isAllowAdd }) {
  const [selected, setSelected] = useState([]);
  const { isOpen: isDeleteModalOpen, onOpen: onDeleteModalOpen, onClose: onDeleteModalClose } = useDisclosure();
  useEffect(() => {
    //map all column and sum total of the colum
    ticketSalesColumn.forEach((column) => {
      _calcSubTotal(column.columnId);
    });
  }, []);

  // This function is use to calculate the value in all the input when on key up
  const _calcPayRaise = (id) => {
    let date = document.getElementById(`ticket-sales-date-${id}`).value;
    let tourist1Day = parseInt(document.getElementById(`ticket-sales-tourist1Day-${id}`).value);
    let tourist3Days = parseInt(document.getElementById(`ticket-sales-tourist3Days-${id}`).value);
    let tourist7Days = parseInt(document.getElementById(`ticket-sales-tourist7Days-${id}`).value);
    let touristOnline1Day = parseInt(document.getElementById(`ticket-sales-touristOnline1Day-${id}`).value);
    let touristOnline3Days = parseInt(document.getElementById(`ticket-sales-touristOnline3Days-${id}`).value);
    let touristOnline7Days = parseInt(document.getElementById(`ticket-sales-touristOnline7Days-${id}`).value);
    let touristLongPass100 = parseInt(document.getElementById(`ticket-sales-touristLongPass100-${id}`).value);
    let touristLongPass150 = parseInt(document.getElementById(`ticket-sales-touristLongPass150-${id}`).value);
    let touristLongPass200 = parseInt(document.getElementById(`ticket-sales-touristLongPass200-${id}`).value);

    // check if the value is
    if (isNaN(tourist1Day)) {
      tourist1Day = 0;
    }
    if (isNaN(tourist3Days)) {
      tourist3Days = 0;
    }
    if (isNaN(tourist7Days)) {
      tourist7Days = 0;
    }
    if (isNaN(touristOnline1Day)) {
      touristOnline1Day = 0;
    }
    if (isNaN(touristOnline3Days)) {
      touristOnline3Days = 0;
    }
    if (isNaN(touristOnline7Days)) {
      touristOnline7Days = 0;
    }
    if (isNaN(touristLongPass100)) {
      touristLongPass100 = 0;
    }
    if (isNaN(touristLongPass150)) {
      touristLongPass150 = 0;
    }
    if (isNaN(touristLongPass200)) {
      touristLongPass200 = 0;
    }

    // Temporary variable use for calculate
    let totalTouristTmp = 0;
    let revenue1DayTmp = 0;
    let revenue3DaysTmp = 0;
    let revenue7DaysTmp = 0;
    let totalTouristRevenueTmp = 0;
    let totalTouristOnlineTmp = 0;
    let totalTouristOnlineRevenueTmp = 0;
    let totalTouristLongPassTmp = 0;
    let totalTouristLongPassRevenueTmp = 0;

    // ticket price
    let T1DPrice = 0;
    let T3DPrice = 0;
    let T7DPrice = 0;
    if (format(new Date(date), "yyyy-MM-dd") >= "2017-02-01") {
      T1DPrice = 37;
      T3DPrice = 62;
      T7DPrice = 72;
    } else {
      T1DPrice = 20;
      T3DPrice = 40;
      T7DPrice = 60;
    }

    // total tourist
    totalTouristTmp = tourist1Day + tourist3Days + tourist7Days;

    // revenue of ticket
    revenue1DayTmp = tourist1Day * T1DPrice;
    revenue3DaysTmp = tourist3Days * T3DPrice;
    revenue7DaysTmp = tourist7Days * T7DPrice;
    totalTouristRevenueTmp = revenue1DayTmp + revenue3DaysTmp + revenue7DaysTmp;

    // ticket online total and revenue
    totalTouristOnlineTmp = touristOnline1Day + touristOnline3Days + touristOnline7Days;
    totalTouristOnlineRevenueTmp = touristOnline1Day * T1DPrice + touristOnline3Days * T3DPrice + touristOnline7Days * T7DPrice;

    // ticket online total and revenue
    totalTouristLongPassTmp = touristLongPass100 + touristLongPass150 + touristLongPass200;
    totalTouristLongPassRevenueTmp = touristLongPass100 * 100 + touristLongPass150 * 150 + touristLongPass200 * 200;

    // call Input field for display to UI
    let totalTourist = document.getElementById(`ticket-sales-totalTourist-${id}`);
    let revenue1Day = document.getElementById(`ticket-sales-revenue1Day-${id}`);
    let revenue3Days = document.getElementById(`ticket-sales-revenue3Days-${id}`);
    let revenue7Days = document.getElementById(`ticket-sales-revenue7Days-${id}`);
    let totalTouristRevenue = document.getElementById(`ticket-sales-totalTouristRevenue-${id}`);
    let totalTouristOnline = document.getElementById(`ticket-sales-totalTouristOnline-${id}`);
    let totalTouristOnlineRevenue = document.getElementById(`ticket-sales-totalTouristOnlineRevenue-${id}`);
    let totalTouristLongPass = document.getElementById(`ticket-sales-totalTouristLongPass-${id}`);
    let totalTouristLongPassRevenue = document.getElementById(`ticket-sales-totalTouristLongPassRevenue-${id}`);

    // display to UI
    totalTourist.value = totalTouristTmp;
    revenue1Day.value = formatToCurrency(revenue1DayTmp);
    revenue3Days.value = formatToCurrency(revenue3DaysTmp);
    revenue7Days.value = formatToCurrency(revenue7DaysTmp);
    totalTouristRevenue.value = formatToCurrency(totalTouristRevenueTmp);
    totalTouristOnline.value = totalTouristOnlineTmp;
    totalTouristOnlineRevenue.value = formatToCurrency(totalTouristOnlineRevenueTmp);
    totalTouristLongPass.value = totalTouristLongPassTmp;
    totalTouristLongPassRevenue.value = formatToCurrency(totalTouristLongPassRevenueTmp);

    ticketSalesColumn.forEach((column) => {
      _calcSubTotal(column.columnId);
    });
  };

  // This function use to set input value to 0 when the input is empty
  const _invalidValue = (columnId, id) => {
    let inputValue = document.getElementById(`ticket-sales-${columnId}-${id}`);
    if (inputValue.value === "") {
      inputValue.value = 0;
    } else {
      inputValue.value = parseInt(inputValue.value);
    }
  };

  // This function is use to calculate Total value
  const _calcSubTotal = (column) => {
    let subColumn = document.getElementsByClassName(`ticket-sales-${column}`);
    let total = 0;
    for (let each of subColumn) {
      if (each.value === "") {
        each.value = 0;
      }
      if (!isNaN(parseInt(each.value))) {
        total += parseInt(each.value);
      } else {
        total += parseToNumber(each.value);
      }
    }

    let totalColumn = document.getElementById(`total-ticket-sales-${column}`);
    if (totalColumn) {
      if (column === "revenue1Day" || column === "revenue3Days" || column === "revenue7Days" || column === "totalTouristRevenue" || column === "totalTouristOnlineRevenue" || column === "totalTouristLongPassRevenue") {
        totalColumn.innerHTML = formatToCurrency(total);
      } else {
        totalColumn.innerHTML = total;
      }
    }
  };
  return (
    <>
      <AlertDialog motionPreset="slideInBottom" isOpen={isDeleteModalOpen} isCentered>
        <AlertDialogOverlay />
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg">Confirmation</AlertDialogHeader>
          <AlertDialogBody>{`Are you sure you want to revert ${selected.length > 1 ? "these ticket sale?" : "this ticket sales?"}`}</AlertDialogBody>
          <AlertDialogFooter>
            <HStack spacing="2">
              <Button onClick={onDeleteModalClose}>No</Button>
              <Button
                colorScheme="red"
                onClick={async () => {
                  onRevertAll(selected);
                  await sleep(100);
                  onDeleteModalClose();
                }}
              >
                Yes
              </Button>
            </HStack>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <Box style={{ position: "sticky", left: "0" }} w="100%" mb="10px">
        <Text textAlign="center" fontSize="25px" fontWeight="bold">
          Ticket Sales for International Tourist Visit to Angkor
        </Text>
        {status === "filter" ? (
          <Text textAlign="center">
            Ticket Sales from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}
          </Text>
        ) : status === "import" ? (
          <Text textAlign="center">
            Ticket Sales from {data?.length > 0 && format(new Date(data[0]?.date), "dd MMMM, yyyy")} to {data?.length > 0 && format(new Date(data[data?.length - 1]?.date), "dd MMMM, yyyy")}
          </Text>
        ) : status === "retrieve" && filter !== undefined ? (
          <Text textAlign="center">
            Ticket Sales from {format(new Date(filter?.dateFrom), "dd MMMM, yyyy")} to {format(new Date(filter?.dateTo), "dd MMMM, yyyy")}
          </Text>
        ) : (
          ""
        )}
      </Box>

      {data?.length > 0 ? (
        <Table w="2000px" size="sm" className="sale-table" borderRight="1px solid black">
          <Thead className="sale-thead">
            <Tr color="#4149BE" fontWeight="bold" className="sale-thead-tr1">
              <Td rowSpan="3" colSpan="1" textAlign="center" w="6%">
                Date
              </Td>
              <Td rowSpan="2" colSpan="4" textAlign="center">
                Tourist (T)
              </Td>
              <Td rowSpan="2" colSpan="4" textAlign="center">
                Revenue (R)
              </Td>
              <Td rowSpan="1" colSpan="10" textAlign="center" px="0">
                ប្រភេទប័ណ្ណផ្សេងៗ ( សំបុត្រលក់អនឡាញ និង​ សំបុត្រសម្រាប់រយៈពេល ១០០$, ១៥០$, ២០០$​ )
              </Td>
              <Td rowSpan="3" colSpan="1" textAlign="center">
                ស្ថានភាព
              </Td>
            </Tr>
            <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className="sale-thead-tr2">
              <Td rowSpan="1" colSpan="5" textAlign="center">
                Tourist Number Buy Online (TO)
              </Td>
              <Td rowSpan="1" colSpan="5" textAlign="center">
                Tourist Number Long Pass (TL)
              </Td>
            </Tr>
            <Tr color="#4149BE" fontWeight="bold" textAlign="center" h="35px" className="sale-thead-tr3">
              <Td textAlign="center" p="0">
                T1D
              </Td>
              <Td textAlign="center" p="0">
                T3Ds
              </Td>
              <Td textAlign="center" p="0">
                T7Ds
              </Td>
              <Td textAlign="center" p="0">
                T TOTAL
              </Td>
              <Td textAlign="center" p="0">
                R1D
              </Td>
              <Td textAlign="center" p="0">
                R3Ds
              </Td>
              <Td textAlign="center" p="0">
                R7Ds
              </Td>
              <Td textAlign="center" p="0">
                R TOTAL
              </Td>
              <Td textAlign="center" p="0">
                TO1D
              </Td>
              <Td textAlign="center" p="0">
                TO3Ds
              </Td>
              <Td textAlign="center" p="0">
                TO7Ds
              </Td>
              <Td textAlign="center" p="0">
                TO TOTAL
              </Td>
              <Td textAlign="center" p="0">
                RO TOTAL
              </Td>
              <Td textAlign="center" p="0">
                TL100
              </Td>
              <Td textAlign="center" p="0">
                TL150
              </Td>
              <Td textAlign="center" p="0">
                TL200
              </Td>
              <Td textAlign="center" p="0">
                TO TOTAL5
              </Td>
              <Td textAlign="center" p="0">
                RO TOTAL6
              </Td>
            </Tr>
          </Thead>

          <Tbody>
            {data?.map((data, index) => {
              return (
                <Tr key={index} h="25px">
                  {ticketSalesColumn.map((item, i) => {
                    return (
                      <Td key={i} w="100px" py="0" p="1">
                        <Input
                          padding="2px"
                          width="100%"
                          height="30px"
                          textAlign="center"
                          borderColor="gray.300"
                          type={item.type}
                          className={`ticket-sales-${item.columnId} ${item.readOnly ? "is-disable-input" : data.status === 1 ? "is-disable-input" : ""}`}
                          id={`ticket-sales-${item.columnId}-${data.id}`}
                          defaultValue={data[item.columnId]}
                          onKeyUp={() => _calcPayRaise(`${data.id}`)}
                          onBlur={() => {
                            _invalidValue(item.columnId, data.id);
                          }}
                        />
                      </Td>
                    );
                  })}
                  <Td width="10px" align="center" py="0">
                    <Flex justifyContent="center">
                      <Button className={data.status === 1 ? "ut-button-dark" : "ut-button-success"} w="20" h="30px" id={`btn-save-${data.id}`} onClick={() => onSaveAll([data])} hidden={!isAllowAdd}>
                        {data.status === 1 ? "Saved" : "Save"}
                      </Button>
                      <Tooltip hasArrow label="Revert" color="black" bg="gray.300">
                        <IconButton
                          onClick={() => {
                            onDeleteModalOpen();
                            setSelected([data]);
                          }}
                          id={`btn-revert-${data.id}`}
                          className={data.status !== 1 ? "is-disable" : ""}
                          variant="ghost"
                          colorScheme="red"
                          size="sm"
                          icon={<TiDelete size="1.7rem" />}
                          hidden={!isAllowEdit}
                        />
                      </Tooltip>
                    </Flex>
                  </Td>
                </Tr>
              );
            })}
            <Tr h="35px">
              {ticketSalesColumn.map((item, i) => {
                return (
                  <Td key={i} p="0" style={{ backgroundColor: "#8497b0", color: "white", textAlign: "center" }}>
                    {i === 0 ? "Total" : <span id={`total-ticket-sales-${item.columnId}`} />}
                  </Td>
                );
              })}
              <Td p="0" style={{ backgroundColor: "#8497b0" }}></Td>
            </Tr>
          </Tbody>
        </Table>
      ) : (
        <Center py="3" w="full" h="70vh" color="gray.400">
          <BiServer size="1.3rem" /> <Text fontSize="md">&nbsp;No data.</Text>
        </Center>
      )}
    </>
  );
}

export default TicketSaleTable;
